import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VBreadcrumbs,{attrs:{"divider":">","items":_vm.breadcrumbs,"exact":""}}),_c('company-crawl-requests',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }